import { Box, Center, Spinner, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr } from '@chakra-ui/react';
import { Formatter } from '../../../utils/Formatter';
import { StatusBadge } from '../../../components/StatusBadge';
import React from 'react';
import { PageableResponseWrapper } from '../../../domain/response-wrapper';
import { Transaction } from '../../../domain/transaction';
import { PaginatorFooter } from '../../../components/PaginatorFooter';

interface TransactionTableProps {
  results: PageableResponseWrapper<Transaction> | null;
  onSelectTransaction: (selected: Transaction) => void;
  onNextPage: () => void;
  onPreviousPage: () => void;
  dataLoading: boolean;
}

const capitalizeText = (text: string) => {
  return text
    .split(' ')
    .map((word, index) => {
      return index === 0
        ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        : word.toLowerCase();
    })
    .join(' ');
};

export const TransactionTable = (props: TransactionTableProps) => {
  const { results, onSelectTransaction, onPreviousPage, onNextPage, dataLoading } = props;

  return (<>
    <TableContainer paddingX="xl" flexGrow="1" overflowY="auto" marginBottom="l">
      <Table variant="simple">
        <Thead>
          <Tr>
            <Th sx={{ textTransform: 'none' }} textAlign="center">{capitalizeText('Sucursal')}</Th>
            <Th sx={{ textTransform: 'none' }} textAlign="center">{capitalizeText('Fecha')}</Th>
            <Th sx={{ textTransform: 'none' }} textAlign="center">{capitalizeText('Hora')}</Th>
            <Th sx={{ textTransform: 'none' }} textAlign="center">{capitalizeText('Tarjeta')}</Th>
            <Th sx={{ textTransform: 'none' }} textAlign="center">{capitalizeText('Operación')}</Th>
            <Th sx={{ textTransform: 'none' }} textAlign="center">{capitalizeText('Tipo')}</Th>
            <Th sx={{ textTransform: 'none' }} textAlign="center">{capitalizeText('Monto bruto')}</Th>
            <Th sx={{ textTransform: 'none' }} textAlign="center">{capitalizeText('Monto neto')}</Th>
            <Th sx={{ textTransform: 'none' }} textAlign="center">{capitalizeText('Fecha liquidación')}</Th>
            <Th sx={{ textTransform: 'none' }} textAlign="center">{capitalizeText('Estado')}</Th>
          </Tr>
        </Thead>
        <Tbody>
          {results && !dataLoading && !results.total_elements &&
            <Tr>
              <Td colSpan={10}>
                <Text textAlign="center" color="neutral.600">No se han realizado transacciones</Text>
              </Td>
            </Tr>
          }

          {dataLoading &&
            <Tr>
              <Td colSpan={10} paddingY="xxl">
                <Center color="neutral.600"><Spinner /></Center>
              </Td>
            </Tr>
          }

          {results && !dataLoading && results.content.map((transaction) => (
            <Tr
              key={transaction.id}
              onClick={() => onSelectTransaction(transaction)}
              cursor="pointer">
              <Td textAlign="center" fontSize="s">{transaction.branch_name}</Td>
              <Td textAlign="center" fontSize="s">
                {Formatter.toDate(transaction.date_time).dateString}
              </Td>
              <Td textAlign="center" fontSize="s">
                {Formatter.toDate(transaction.date_time).timeString}
              </Td>
              <Td textAlign="center" fontSize="s">{transaction.card_brand}</Td>
              <Td textAlign="center" fontSize="s">{transaction.operation_number}</Td>
              <Td textAlign="center"
                  fontSize="s">{capitalizeText(Formatter.typeToString(transaction.operation_type))}</Td>
              <Td textAlign="center"
                  fontSize="s">{Formatter.toCurrency(transaction.gross_amount, transaction.currency)}</Td>
              <Td textAlign="center"
                  fontSize="s">{Formatter.toCurrency(transaction.net_amount, transaction.currency)}</Td>
              <Td textAlign="center" fontSize="s">
                {transaction.payment_date ? Formatter.toDate(transaction.payment_date).dateString : '-'}
              </Td>
              <Td textAlign="center" fontSize="s"><StatusBadge status={transaction.status} /></Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </TableContainer>

    {results &&
      <Box marginTop="auto">
        <PaginatorFooter
          pageable={results.pageable}
          total_elements={results.total_elements}
          onPreviousPage={onPreviousPage}
          onNextPage={onNextPage} />
      </Box>
    }
  </>);
};
